import React from "react";

export default function PartnersBlockItem({partner}) {

    return (
        <a className="partner-item">
            <img src={process.env.REACT_APP_API_URL + "/files/" + partner.imageId} alt=""/>
        </a>
    )
}